(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/bet-events/assets/bet-events.js') >= 0) return;  svs.modules.push('/components/tipsen/bet-events/assets/bet-events.js');
"use strict";


const BetEvent = svs.components.tipsen.betEvents.BetEvent;
const clx = svs.components.lbUtils.clx;
const DraggableContainer = svs.components.lbUi.DraggableContainer;
const BetEventsContent = _ref => {
  let renderedBetEvents = _ref.renderedBetEvents,
    remainingBetEvents = _ref.remainingBetEvents;
  return React.createElement(React.Fragment, null, React.createElement("ol", {
    className: "pg_bet_events--container"
  }, renderedBetEvents.map(_ref2 => {
    let awayParticipant = _ref2.awayParticipant,
      betEventId = _ref2.betEventId,
      homeParticipant = _ref2.homeParticipant;
    return React.createElement(BetEvent, {
      awayParticipant: awayParticipant,
      homeParticipant: homeParticipant,
      key: betEventId
    });
  })), remainingBetEvents > 0 && React.createElement("div", {
    className: "pg_bet_events__remaining_count"
  }, "+ ".concat(remainingBetEvents)));
};
const BetEvents = _ref3 => {
  let _ref3$betEvents = _ref3.betEvents,
    betEvents = _ref3$betEvents === void 0 ? [] : _ref3$betEvents,
    className = _ref3.className,
    limitToNumber = _ref3.limitToNumber;
  const renderedBetEvents = limitToNumber && limitToNumber < betEvents.length ? betEvents.slice(0, limitToNumber) : betEvents;
  const remainingBetEvents = limitToNumber ? betEvents.length - limitToNumber : 0;
  const hasDraggableScrolling = renderedBetEvents.length > 1;
  if (Array.isArray(betEvents) && betEvents.length === 0) {
    return null;
  }
  const classNames = clx('pg_bet_events', {
    'pg_bet_events--limited': remainingBetEvents > 0
  }, className);
  if (hasDraggableScrolling) {
    return React.createElement(DraggableContainer, {
      className: classNames
    }, React.createElement(BetEventsContent, {
      remainingBetEvents: remainingBetEvents,
      renderedBetEvents: renderedBetEvents
    }));
  }
  return React.createElement("div", {
    className: classNames
  }, React.createElement(BetEventsContent, {
    remainingBetEvents: remainingBetEvents,
    renderedBetEvents: renderedBetEvents
  }));
};
setGlobal('svs.components.tipsen.betEvents.BetEvents', BetEvents);

 })(window);